/* Package JSON Import will be here */
import React from 'react';
import { Button, Form, Segment } from 'semantic-ui-react';
/* Package JSON Import will be here */

/* Project Import will be here */
import './login.css';
import { configSettings } from "../../config/configSettings";
/* Project Import will be here */

const LoginComponent = props => {
    return (
        <Segment className="login-bg">
            <Form size='large'>
                <label className="login-logo leftUserName">
                    <img src={require('../../assets/images/logo.png')} alt="logo" />
                    <span style={{ color: "#606c76", marginLeft: '10px' }}> | {'TIME ADMIN CONSOLE'}</span>
                </label>
                <div className="login-form">
                    <Form.Input
                        fluid
                        icon='user'
                        iconPosition='right'
                        onChange={(e) => { props.onChangeEmailOrPassword(e.target.value, "Email"); }}
                        placeholder='User name'
                        value={props.login.email}
                        error={props.login.isEmailEmpty ? { content: 'User name is required!' } : false}
                    />
                    <Form.Input
                        fluid
                        icon='lock'
                        iconPosition='right'
                        onChange={(e) => { props.onChangeEmailOrPassword(e.target.value, "Password"); }}
                        placeholder='Password'
                        value={props.login.password}
                        type='password'
                        error={props.login.isPasswordEmpty ? { content: 'Password is required!' } : false}
                    />
                    <Button className="buttonLogin" fluid size='small' color="#094b73" onClick={props.handleLogin}>
                        Login
                    </Button>
                </div>
            </Form>
            <label className="bottom">{configSettings.copyrightContent}</label>
        </Segment>
    );
};

LoginComponent.displayName = "LoginComponent";

export default LoginComponent;